import { defineStyleConfig } from "@chakra-ui/react";

export const LinksTheme = defineStyleConfig({
	baseStyle: {
		color: "blue"
	},
	defaultProps: {
		size: "xl",
		colorScheme: "orange"
	}
});
